import { sprintf } from 'sprintf-js';

import { apiInstance } from 'api/utils';
import { SearchParamsType } from 'api/types';

import { BriefingType } from './briefings.types';

const URLS = {
  BRIEFINGS: '/products/briefings/',
  BRIEFING: '/products/briefings/%s/',
};

export default {
  getBriefings: (params: SearchParamsType = {}) =>
    apiInstance.request({
      method: 'GET',
      url: URLS.BRIEFINGS,
      params,
    }),
  createBriefing: (briefing: BriefingType) =>
    apiInstance.request({
      method: 'POST',
      url: URLS.BRIEFINGS,
      data: briefing,
    }),
  getBriefing: ({ id }: { id: BriefingType['id'] }) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.BRIEFING, id),
    }),
  updateBriefing: (briefing: BriefingType) =>
    apiInstance.request({
      method: 'PATCH',
      url: sprintf(URLS.BRIEFING, briefing.id),
      data: briefing,
    }),
  removeBriefing: ({ id }: { id: BriefingType['id'] }) =>
    apiInstance.request({
      method: 'DELETE',
      url: sprintf(URLS.BRIEFING, id),
    }),
};
